import Component from '../core/Component'
import { query, triggerEvent } from '../utils/dom'
import { najaAjax } from '../utils/ajax'
import { createLoading } from '../meta/loading'

/* horni cast (tj.obrazky,kod,dostupnost,video,model,...) jsou pri zmene varianty meneny pres JS */
/* na dalsi sekce sou volany nette ajax request a prekresluje BE */
/* pokud zmeni select v dalsich sekcich, aktualizuje se zaroven i horni cast */
export default class ProductDetail extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            intro: null,
            name: null,
            available: null,
            notAvailable: null,
            rotatorBase: null,
            code: null,
            code2: null,
            colorLists: [],
            surfaces: [],
            tabsComp: null,
            productImage: null,
            tagList: null,
            jsonData: null,
            productGallery: null,
        }

        this.jsonData = JSON.parse(this.ref.jsonData.innerText)
        this.currentProductEntityId = null
        this.currentSurface = null
        this.requests = {
            parameter: null,
            document: null,
        }
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)

        setTimeout(() => {
            this.checkIntro()
        }, 0)
    }

    handleChange = (event) => {
        const element = event.target
        const selectParameterEl = query('[name="parameter"]', this.element)
        const selectDocumentEl = query('[name="document"]', this.element)

        if (this.ref.intro.contains(element)) {
            this.checkIntro()
        } else if (element == selectParameterEl) {
            this.setVariantInIntro(selectParameterEl.value)
            this.updateParameters(selectParameterEl.value)
        } else if (element == selectDocumentEl) {
            this.setVariantInIntro(selectDocumentEl.value)
            this.updateDocuments(selectDocumentEl.value)
        }
    }

    updateParameters(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }

        const url = productEntity.urlShowParameters
        if (!url) {
            return
        }

        if (this.requests.parameter) {
            this.requests.parameter.abort()
        }

        let loading = null
        this.requests.parameter = najaAjax({
            url,
            before() {
                const element = query('.product-TechnicalPaper', this.element)
                loading = createLoading(element)
                loading.show()
            },
            complete() {
                loading.destroy()
            },
        })
    }

    updateDocuments(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }

        const url = productEntity.urlShowDocuments
        if (!url) {
            return
        }

        if (this.requests.document) {
            this.requests.document.abort()
        }

        let loading = null
        this.requests.document = najaAjax({
            url,
            before() {
                const element = query('#snippet--productDocuments .Container:nth-child(2)', this.element)
                loading = createLoading(element)
                loading.show()
            },
            complete() {
                loading.destroy()
            },
        })
    }

    updateSubcategories(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }

        const url = productEntity.urlShowSubcategories
        if (!url) {
            return
        }

        if (this.requests.subcategory) {
            this.requests.subcategory.abort()
        }
        let loading = null
        this.requests.subcategory = najaAjax({
            url,
            before() {
                const element = query('#snippet--productSubcategories', this.element)
                loading = createLoading(element)
                loading.show()
            },
            complete() {
                loading.destroy()
            },
        })
    }

    updateImages(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity || typeof productEntity.images === 'undefined') {
            return
        }

        const productGallery = Component.getFromElement(this.ref.productGallery)
        if (productGallery) {
            productGallery.setImages(productEntity.images)
        }
    }

    updateSurfaceImages(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity || !productEntity.surfaceImages) {
            return
        }

        this.ref.surfaces.forEach((surfaceEl, index) => {
            const imageSrc = productEntity.surfaceImages[index]
            if (!imageSrc) {
                return
            }
            const { src, srcset } = createProductImageAttributes(imageSrc)

            const image = surfaceEl.querySelector('img')
            image.src = src
            image.srcset = srcset
        })
    }

    updateContactForm(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }

        const form = document.getElementById('frm-contactForm')
        if (!form) {
            return
        }

        form.action = productEntity.url
    }

    updateRotatorImages(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }
        const rotatorBase = Component.getFromElement(this.ref.rotatorBase)
        if (rotatorBase) {
            rotatorBase.setImages(productEntity.modelImages)
        }
    }

    updateTabs(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }

        const modelLinks = [...document.querySelectorAll('[data-producttab="#model"]')]
        modelLinks.forEach(link => {
            if (productEntity.modelImages.length) {
                link.classList.remove('hidden')
            } else {
                link.classList.add('hidden')
            }
        })

        const tabsComp = Component.getFromElement(this.ref.tabsComp)
        if (tabsComp) {
            tabsComp.checkIfActiveIsVisible()
            tabsComp.resize()
        }
    }

    updateName(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]
        if (!productEntity) {
            return
        }
        this.ref.name.innerHTML = productEntity.name
    }

    checkIntro() {
        requestAnimationFrame(this._checkIntro)
    }

    _checkIntro = () => {
        let productEntityId = null

        const currentVariantEl = query('input[name="variant"]:checked, select[name="variant"]', this.element)
        if (!currentVariantEl) {
            return
        }

        productEntityId = currentVariantEl.value

        //kontrola, jestli je checknuta varianta videt
        //pokud ne =>
        // 1. zkusi to najit viditelnou veriantu stejny barvy
        // 2. checkne to prvni viditelnou variantu
        const variantGroupEl = currentVariantEl.closest('[data-variantgroup]')
        if (variantGroupEl) {
            const styles = window.getComputedStyle(variantGroupEl)
            if (styles.display === 'none') {
                const variantGroupEls = [...this.element.querySelectorAll('[data-variantgroup]')]
                variantGroupEls.forEach((variantGroupEl) => {
                    const styles = window.getComputedStyle(variantGroupEl)
                    if (styles.display !== 'none') {
                        const variantEl = variantGroupEl.querySelector(`[name="variant"][data-color="${currentVariantEl.dataset.color}"]`)
                        if (variantEl) {
                            variantEl.checked = true
                            productEntityId = variantEl.value
                        } else {
                            const variantEl = variantGroupEl.querySelector(`[name="variant"]`)
                            if (variantEl) {
                                variantEl.checked = true
                                productEntityId = variantEl.value
                            }
                        }
                    }
                })
            }
        }

        if (productEntityId !== null && productEntityId === this.currentProductEntityId) {
            return
        }

        this.render(productEntityId)
    }

    setVariantInIntro(productEntityId) {
        const introVariantEl = query(`input[name="variant"][value="${productEntityId}"], select[name="variant"]`, this.element)
        if (!introVariantEl) {
            return false
        }

        if (introVariantEl.tagName === 'SELECT') {
            introVariantEl.value = productEntityId
        } else {
            introVariantEl.checked = true
        }
        triggerEvent(introVariantEl, 'change')

        return true
    }

    render(productEntityId) {
        const productEntity = this.jsonData.variants[productEntityId]

        if (productEntity.available) {
            this.ref.notAvailable.classList.add('hidden')
            this.ref.available.classList.remove('hidden')
        } else {
            this.ref.available.classList.add('hidden')
            this.ref.notAvailable.classList.remove('hidden')
        }
        this.ref.code.innerHTML = productEntity.code
        if (this.ref.code2) {
            this.ref.code2.innerHTML = productEntity.code
        }
        if (this.ref.tagList) {
            this.ref.tagList.innerHTML = productEntity.tags.map(tag => `<span class="Tag Tag--${tag[0]}"><span class="Tag-label">${tag[1]}</span></span>`).join('')
        }

        //pri prvnim loadu netrigrovat zmeny
        if (this.currentProductEntityId) {
            history.replaceState({}, '', productEntity.url)
            document.title = productEntity.metaTitle

            const documentEl = query('[name="document"]', this.element)
            if (documentEl) {
                documentEl.value = productEntityId
                triggerEvent(documentEl, 'change')
            }

            const parameterEl = query('[name="parameter"]', this.element)
            if (parameterEl) {
                parameterEl.value = productEntityId
                triggerEvent(parameterEl, 'change')
            }

            this.updateName(productEntityId)
            this.updateParameters(productEntityId)
            this.updateSubcategories(productEntityId)
            this.updateImages(productEntityId)
            this.updateContactForm(productEntityId)
            this.updateSurfaceImages(productEntityId)
            this.updateRotatorImages(productEntityId)
            this.updateTabs(productEntityId)
        }

        this.currentProductEntityId = productEntityId
    }
}


function splitStringAtIndex(value, index) {
    return [value.substring(0, index), value.substring(index)]
}

function createProductImageAttributes(imageSrc) {
    let index = imageSrc.lastIndexOf('.')
    const [src, extension] = splitStringAtIndex(imageSrc, index)

    return {
        src: `${src}.180x180.fit.q85${extension}`,
        srcset: `
        ${src}.70x70.fit.q85${extension} 70w,
        ${src}.140x140.fit.q85${extension} 140w,
        ${src}.180x180.fit.q85${extension} 180w,
        ${src}.360x360.fit.q85${extension} 360w,
        ${src}.800x800.fit.q85${extension} 800w,
        ${src}.1600x1600.fit.q65${extension} 1600w
        `
    }
}